/* eslint-disable */
import React from 'react';
import { Grid, Paper, Typography, Box, Container, Divider } from '@material-ui/core';

const PrivacyNotice = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Container maxWidth="lg" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
          <Paper elevation={0} style={{ padding: '40px', backgroundColor: '#f9f9f9' }}>
            <Typography
              variant="h1"
              component="h1"
              style={{ marginBottom: '20px', textAlign: 'center' }}
            >
              Privacy Notice
            </Typography>
            <Typography
              variant="body2"
              style={{ marginBottom: '30px', textAlign: 'center', fontStyle: 'italic' }}
            >
              Last Updated: [Date]
            </Typography>
            <Divider style={{ marginBottom: '30px' }} />

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              1. Introduction
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              2. Information We Collect
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '15px', lineHeight: '1.6' }}>
              <strong>Personal Information You Provide:</strong> Lorem Ipsum is simply dummy text of
              the printing and typesetting industry.
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              <strong>Automatically Collected Information:</strong> Lorem Ipsum is simply dummy text
              of the printing and typesetting industry.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              3. How We Use Your Information
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '10px', lineHeight: '1.6' }}>
              We use the information we collect for the following purposes:
            </Typography>
            <Box component="ul" style={{ marginBottom: '25px', paddingLeft: '20px' }}>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
            </Box>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              4. Sharing Your Information
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '10px', lineHeight: '1.6' }}>
              We do not sell your personal information. We may share your information in the
              following limited circumstances:
            </Typography>
            <Box component="ul" style={{ marginBottom: '25px', paddingLeft: '20px' }}>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>With Your Consent:</strong> Lorem Ipsum is simply dummy text of the printing
                and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>Service Providers:</strong> Lorem Ipsum is simply dummy text of the printing
                and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>Legal Requirements:</strong> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry.
              </Typography>
            </Box>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              5. Your Choices & Rights
            </Typography>
            <Box component="ul" style={{ marginBottom: '25px', paddingLeft: '20px' }}>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>Access and Correction:</strong> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>Marketing Emails:</strong> Lorem Ipsum is simply dummy text of the printing
                and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>Cookies:</strong> Lorem Ipsum is simply dummy text of the printing and
                typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                <strong>Do Not Share My Personal Information:</strong> Lorem Ipsum is simply dummy
                text of the printing and typesetting industry.
              </Typography>
            </Box>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              6. Data Security
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              7. Contact Us
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '10px', lineHeight: '1.6' }}>
              If you have any questions about this Privacy Notice or your data, please contact us
              at:
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '5px', lineHeight: '1.6' }}>
              Email: Lorem Ipsum is simply dummy text.
            </Typography>
            <Typography variant="body1" style={{ lineHeight: '1.6' }}>
              Address: Lorem Ipsum is simply dummy text.
            </Typography>
          </Paper>
        </Container>
      </Grid>
    </Grid>
  );
};

export default PrivacyNotice;
